import { render, staticRenderFns } from "./CheckboxDropdownItem.vue?vue&type=template&id=f42636f6&scoped=true&"
import script from "./CheckboxDropdownItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxDropdownItem.vue?vue&type=style&index=0&id=f42636f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42636f6",
  null
  
)

export default component.exports